/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertySummaryTypeUIDTOV0 } from './propertySummaryTypeUIDTOV0';


export interface PropertySummaryUIDTOV0 { 
    walls?: Array<PropertySummaryTypeUIDTOV0>;
    roofs?: Array<PropertySummaryTypeUIDTOV0>;
    floors?: Array<PropertySummaryTypeUIDTOV0>;
    window?: PropertySummaryTypeUIDTOV0;
    mainHeating?: Array<PropertySummaryTypeUIDTOV0>;
    mainHeatingControls?: Array<PropertySummaryTypeUIDTOV0>;
    hotWater?: PropertySummaryTypeUIDTOV0;
    lighting?: PropertySummaryTypeUIDTOV0;
    secondaryHeating?: PropertySummaryTypeUIDTOV0;
    hasHotWaterCylinder?: boolean;
    hasHeatedSeparateConservatory?: boolean;
    /**
     * A string such as Detached house or Top-floor flat
     */
    dwellingType?: string;
    hasFixedAirConditioning?: boolean;
    /**
     * If all windows measured, fraction of windows that are multiply glazed to nearest 1%.
     */
    multipleGlazedProportion?: number;
}

